<script>
    /*
    	ReferralSection.svelte

        Contains a <ReferralHeader> and <ReferralQuestions>

        10/19 TODO: move required checks into each section?
        10/19 TODO: improve the shouldShowQuestion to handle hidden required fields

    */

    import { onMount } from 'svelte';

    // TCARE components
    import ReferralHeader from './ReferralHeader.svelte';
    import ReferralQuestionSet from './ReferralQuestionSet.svelte';

    import ContinueButton from './ContinueButton.svelte';
    import ConnectButton from './ConnectButton.svelte';
    import CancelButton from './CancelButton.svelte';

    // SMUI components

    export let section;
    export let expandedSectionId;
    export let setExpanded;             // in ReferralSections - also checks requireds
    export let submitReferral;          // only needed for final but passed to all

    $: isExpanded = section.sectionId === expandedSectionId;

    onMount(() => {
    })

    const setValue = (source, prop, value) => {
        // console.log('ReferralSection.setValue: ', source, prop, value);
        source[prop] = value;
        section = section;          // Svelte refresh - must do this
    }

</script>

<style>
    .referral-section {
        width: 100%;
        margin-bottom: 5px;
        /* border: 1px solid red; */
    }

    .referral-section .button-row {
        margin: 40px 0px;
        /* border: 1px solid red; */
    }

    .spacer-127w {
        width: 127px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


<!-- TODO: make ReferralQuestion components -->

<div class="referral-section">
    <!-- header is always visible but expanded or collapsed -->
    <ReferralHeader {section} {isExpanded} {setExpanded} />

    {#if isExpanded}
        <!-- could just iterate the questions here without a comp -->
        <ReferralQuestionSet {section} {setValue} />

        {#if section.nextSectionId}
            <div class="flex-center button-row">
                <ContinueButton nextSectionId={section.nextSectionId} {setExpanded} />
            </div>
        {:else}
            <!-- we are on the final page -->
            <div class="flex-row jc-between button-row">
                <CancelButton />
                <ConnectButton {submitReferral} />
                <div class="spacer-127w"></div>
            </div>
        {/if}
    {/if}
</div>
